import { useCallback } from "react";
import { useSettingsAt } from "@/hooks/useTenantPath";
import { useScopedWatch } from "@/hooks/useScopedWatch";
import { settingsAtKey } from "@/domain/tenantPath";
import { systemSettingsRepo } from "@/services/system_settings.repository";
import {
  DEFAULT_CAMERA_CONFIG,
  parseCameraConfig,
  type CameraConfig,
} from "@/domain/camera";

/**
 * 공장 CCTV 설정(factory_camera, 지금 법인·사업부) 구독. 중앙 레미콘 = system_settings/factory_camera.
 * 문서가 없거나 read 실패면 비활성 기본값 → 패널 자체가 렌더되지 않는다.
 */
export function useCameraConfig(): { config: CameraConfig; loaded: boolean } {
  const at = useSettingsAt();
  const subscribe = useCallback(
    (cb: (v: CameraConfig) => void, onError: (e: Error) => void) =>
      systemSettingsRepo.watch(at, "factory_camera", (v) => cb(parseCameraConfig(v)), onError),
    [at],
  );
  const { value, loaded } = useScopedWatch(settingsAtKey("factory_camera", at), subscribe, DEFAULT_CAMERA_CONFIG);
  return { config: value, loaded };
}
